<ng-container *ngTemplateOutlet="horizontal ? horizontalTemplate : defaultTemplate" />

<ng-template #defaultTemplate>
  <div class="ratings-bar">
    <div class="ratings-bar-labels">
      <div
        class="ratings-bar-label"
        [class.large]="largeLabel">
        <topo-horizon-category-rank-icon [rank]="categoryRank" [size]="largeLabel ? 24 : 16" />
        <span>{{ label }}</span>
      </div>
      <div
        class="ratings-bar-label"
        [class.large]="largeLabel">
        @if (value > 0) {
          <span>{{ value | number: '1.2-2' }}</span>
        }
        @if (value === 0) {
          <span>&mdash;</span>
        }
      </div>
    </div>
    <progress
      #progressBar
      [class]="progressBarClass"
      [value]="value"
    [max]="max()"></progress>
  </div>
</ng-template>

<ng-template #horizontalTemplate>
  <div class="ratings-bar is-horizontal">
    <div
      class="ratings-bar-label"
      [class.large]="largeLabel">
      <topo-horizon-category-rank-icon [rank]="categoryRank" [size]="largeLabel ? 24 : 16" />
      <span>{{ label }}</span>
    </div>
    <progress
      #progressBar
      [style.width]="horizontalBarWidth"
      [class]="progressBarClass"
      [value]="value"
    [max]="max()"></progress>
    <div
      class="ratings-bar-label"
      [class.large]="largeLabel">
      @if (value > 0) {
        <span>{{ value | number : '1.2-2' }}</span>
      }
      @if (value === 0) {
        <span>&mdash;</span>
      }
    </div>
  </div>
</ng-template>
